import { render, staticRenderFns } from "./TooltipDescription.vue?vue&type=template&id=c5b582b8&scoped=true&"
import script from "./TooltipDescription.vue?vue&type=script&lang=js&"
export * from "./TooltipDescription.vue?vue&type=script&lang=js&"
import style0 from "./TooltipDescription.vue?vue&type=style&index=0&id=c5b582b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b582b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
